// Pick an existing building, or create a new one in place ("No matches – Create new
// building?") without leaving the page you're on.

import { useState } from 'react';
import { BuildingForm } from '../pages/Buildings';
import { BuildingPicker } from './Pickers';

export function BuildingChooser({ onChosen }: { onChosen: (b: { id: string; label: string }) => void }) {
  const [creating, setCreating] = useState<string | null>(null);
  if (creating !== null) {
    return (
      <div className="rounded-md border border-indigo-100 bg-indigo-50/40 p-3">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wide text-indigo-700">New building</span>
          <button type="button" className="text-xs text-slate-500 hover:underline" onClick={() => setCreating(null)}>
            back to search
          </button>
        </div>
        <BuildingForm initialStreet={creating} onDone={(id, label) => (setCreating(null), onChosen({ id, label }))} />
      </div>
    );
  }
  return <BuildingPicker onPick={(o) => onChosen({ id: o.id, label: o.label })} onCreate={(typed) => setCreating(typed)} />;
}
